// TODO: Confirm minutesToRead values with Product

export const MAIN_BLOG_ARTICLES_DATA = [
    {
        title: 'Career Transitions & Changes: Pursuing a New Career Path',
        url: 'https://blog.udemy.com/how-to-plan-your-career-change/',
        author: 'Heather Ishikawa',
        thumbnail: 'https://blog.udemy.com/wp-content/uploads/2024/11/Heather_Ishikawa-160x160.jpg',
        minutesToRead: 9,
    },
    {
        title: 'How to Become an AI Engineer',
        url: 'https://blog.udemy.com/how-to-become-an-ai-engineer/',
        author: 'Nedko Krastev',
        thumbnail:
            'https://blog.udemy.com/wp-content/uploads/2025/07/nedko_krastev_author_photo-160x160.jpg',
        minutesToRead: 15,
    },
    {
        title: 'High-Demand Cybersecurity Jobs to Pursue',
        url: 'https://blog.udemy.com/cybersecurity-jobs/',
        author: 'Moulika Bollinadi',
        thumbnail: 'https://blog.udemy.com/wp-content/uploads/2025/04/IMG_5664-160x160.jpg',
        minutesToRead: 12,
    },
    {
        title: 'How to Earn a Microsoft Excel Certification',
        url: 'https://blog.udemy.com/microsoft-excel-certification/',
        author: 'Jason Ford',
        thumbnail:
            'https://blog.udemy.com/wp-content/uploads/2025/01/Jason-Ford-2024-Square-160x160.jpg',
        minutesToRead: 14,
    },
    {
        title: 'How to Become a Social Media Influencer',
        url: 'https://blog.udemy.com/how-to-become-a-social-media-influencer/',
        author: 'Jennifer Kim',
        thumbnail:
            'https://blog.udemy.com/wp-content/uploads/2025/07/jennifer_kim_author_photo-160x160.jpg',
        minutesToRead: 13,
    },
    {
        title: 'Is Technology a Good Career Path',
        url: 'https://blog.udemy.com/is-technology-a-good-career-path/',
        author: 'James Young',
        thumbnail:
            'https://blog.udemy.com/wp-content/uploads/2025/03/james_young_author_photo-160x160.jpeg',
        minutesToRead: 16,
    },
];

export const TRENDING_TOPICS_BLOG_ARTICLES_DATA = [
    {
        title: 'What is Prompt Engineering?',
        url: 'https://blog.udemy.com/what-is-prompt-engineering/',
        author: 'Joao Carlos da Silva Junior',
        thumbnail:
            'https://blog.udemy.com/wp-content/uploads/2025/06/joao_carlos_da_silva_blog_author_photo-e1751315314129-160x160.jpg',
        minutesToRead: 10,
    },
    {
        title: 'Building a Custom GPT for Beginners',
        url: 'https://blog.udemy.com/how-to-build-a-custom-gpt-guide/',
        author: 'Francisco Alvarez',
        thumbnail:
            'https://blog.udemy.com/wp-content/uploads/2025/06/francisco_alvarez_blog_author_photo-160x160.jpeg',
        minutesToRead: 11,
    },
    {
        title: 'What is Vibe Coding',
        url: 'https://blog.udemy.com/what-is-vibe-coding/',
        author: 'Carlos Delrio',
        thumbnail:
            'https://blog.udemy.com/wp-content/uploads/2025/06/carlos_del_rio_author_pic-scaled-e1750710410138-160x160.jpg',
        minutesToRead: 8,
    },
];
